import React, { useContext, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { apiFetch } from '../../Util';
import MarkupPercentControl from './MarkupPercentControl';
import OrderMessageControl from './OrderMessageControl';
import ToEmailModal from './ToEmailModal';
import { sessionUserContext } from '../../Context/sessionUserContext';
import { savedCartContext } from '../../Context/savedCartContext';
import { getOrCreateActiveSavedCart } from '../../Util/SavedCart';
import { createUserOrder } from '../../Util/UserOrder';
import IfCartUser from '../../Components/IfCartUser';

const THANK_YOU_MESSAGE = "Thank you for your request. A member of the " +
  "Diagem team will reach out shortly to confirm availability.";

function ResultItemsActions(props) {
  const { selectedItems, emptyItems, showSave } = props;
  const diamondIdList = Object.keys(selectedItems);

  const sessionUser = useContext(sessionUserContext);
  const [markupPercent, setMarkupPercent] = useState(0);
  const [messageBody, setMessageBody] = useState('');
  const [toEmailAddress, setToEmailAddress] = useState(sessionUser.userAccount.emailAddress);
  const [showToEmailModal, setShowToEmailModal] = useState(false);

  async function saveToCart(savedCartId, diamondIdList) {
    const createParams = {
      diamond_id_list: diamondIdList
    };
    const response = await apiFetch.create(
      ['saved_cart', savedCartId, 'diamond'],
      createParams
    );
    return response.created;
  }

  async function handleEmailReportWithDestination(modalData) {
    const createParams = {
      markup_percent: markupPercent,
      diamond_id_list: diamondIdList,
      to_email_address: modalData['to_email_address'],
    };
    setShowToEmailModal(false);
    setToEmailAddress(modalData['to_email_address']);
    return apiFetch.create(['diamond_detail_email'], createParams)
      .then((response) => {
        alert(`Email sent to '${response.created.emailRecipientList}'`);
      })
      .catch((error) => {
        alert('Error creating email: ' + error);
      });
  }

  async function handleEmailReport() {
    const createParams = {
      markup_percent: markupPercent,
      diamond_id_list: diamondIdList,
    };
    if(sessionUser.userAccount.groups.includes('admin')){
      setShowToEmailModal(true);
    }
    else {
      return apiFetch.create(['diamond_detail_email'], createParams)
        .then((response) => {
          alert(`Email sent to '${response.created.emailRecipientList}'`);
        })
        .catch((error) => {
          alert('Error creating email: ' + error);
        });
    }
  }

  async function startFileExport (fileType) {
    const newUserOrder = await createUserOrder('export', diamondIdList, markupPercent);
    try {
      const url = apiFetch.fetchUrl(
        ['user_order', newUserOrder.id, 'export', fileType])
      const params = `markup_percent=${markupPercent}`;
      const exportUrl = `${url}?${params}`;
      window.open(exportUrl);
    } catch (e) {
      alert("Error creating or transferring export file.");
    }
  }

  async function startOrder () {
    await createUserOrder('request', diamondIdList, 0.0, messageBody);
    alert(THANK_YOU_MESSAGE);
    emptyItems();
  }

  const { refreshSavedCartDetails } = useContext(savedCartContext);

  async function saveSelectionToCart () {
    const activeSavedCart = await getOrCreateActiveSavedCart();
    try {
      await saveToCart(activeSavedCart.id, diamondIdList);
      alert(`Items placed in cart`);
    } catch(e) {
      alert('Error saving items to cart');
    }
    await refreshSavedCartDetails();
    emptyItems();
  }

  function markupChanged (e) {
    setMarkupPercent(e.currentTarget.value);
  }

  function messageBodyChanged (e) {
    setMessageBody(e.currentTarget.value);
  }

  function handleDestinationCancel() {
    setShowToEmailModal(false);
  }

  return (
    <div>
      { showToEmailModal &&
        <ToEmailModal
          onCancel={handleDestinationCancel}
          onConfirm={handleEmailReportWithDestination}
          toEmailAddress={toEmailAddress}
        />
      }
      <div className="d-inline-flex justify-content-around w-100">
        <div className="border w-50 p-3 m-3">
          <h2>Export</h2>
          Export as<br/>
          <Button onClick={() => startFileExport('pdf')}>PDF</Button>
          &nbsp;
          <Button onClick={() => startFileExport('xls')}>XLS</Button>
          &nbsp;
          <Button onClick={handleEmailReport}>Email Report</Button>
          <br/><br/>
          <strong>Optional: </strong>
          Enter a markup for the prices that appear in the export document
          <MarkupPercentControl value={markupPercent} onChange={markupChanged} />
        </div>
        <div className="border w-50 p-3 m-3">
          <h2>Inquire</h2>
          Inquire as to availability of selected stones
          <br/>
          <Button onClick={startOrder}>Start Inquiry</Button>
          <br/><br/>
          <strong>Order Comments (optional): </strong>
          <OrderMessageControl value={messageBody} onChange={messageBodyChanged} />
        </div>
        <IfCartUser>
          { showSave &&
            <div className="border w-50 p-3 m-3">
              <h2>Save</h2>
              Save selected items to cart
              <br/>
              <Button onClick={saveSelectionToCart}>Add to Cart</Button>
            </div>
          }
        </IfCartUser>
      </div>
    </div>
  );
}

export default ResultItemsActions;
